import Text from '@creator/ui/components/Text/Text';
import type { ParagraphData } from '@editorjs/paragraph';
import { cleanHtml } from '@src/utils/html-utils/html-utils';
import { memo } from 'react';
import type { FC } from 'react';

export interface EditorViewOnlyParagraphToolProps {
    className?: string;
    blockData: ParagraphData;
}

const EditorViewOnlyParagraphTool: FC<EditorViewOnlyParagraphToolProps> = props => {
    const { blockData, className } = props;

    function renderContent() {
        const { text } = blockData;

        // Replace embed patterns with iframe HTML
        const _html = cleanHtml(text);
        const htmlWithEmbed = _html.replace(/\[embed\](.*?)\[\/embed\]/g, (_match, url) => {
            return `<iframe 
                title="Embedded Content" 
                class="aspect-video"
                src="${ensureEmbedUrl(url)}" 
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
                allowfullscreen>
            </iframe>`;
        });

        return (
            <div className="ce-paragraph cdx-block">
                <p dangerouslySetInnerHTML={{ __html: htmlWithEmbed }} />
            </div>
        );
    }

    function ensureEmbedUrl(url: string) {
        const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/;
        if (youtubeRegex.test(url)) {
            // Convert watch urls to embed urls
            const watchUrlRegex = /^(https?:\/\/)?(www\.)?(youtube\.com\/watch\?v=)(.+)$/;
            if (watchUrlRegex.test(url)) return `https://www.youtube.com/embed/${watchUrlRegex.exec(url)?.[4]}`;
            return url;
        }

        return url;
    }

    return <div className={`paragraph-tool ${className}`}>{renderContent()}</div>;
};

export default memo(EditorViewOnlyParagraphTool);
